<template>
  <div class="page">
    <div class="header">
      <div class="logo">
        <img src="../assets/images/header_logo.png" alt="" />
      </div>
      <a class="about-us" @click="jumpClick()">About Us</a>
    </div>
    <div class="swiper-box">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide class="swiper-slide">
          <img src="../assets/images/banner_1.jpg" alt="" />
          <img id="play" src="../assets/images/play_1.png" alt="" />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="../assets/images/banner_2.jpg" alt="" />
          <img id="play-2" src="../assets/images/play_2.png" alt="" />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="../assets/images/banner_3.jpg" alt="" />
          <img id="play-3" src="../assets/images/play_3.png" alt="" />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="../assets/images/banner_4.jpg" alt="" />
          <img id="play-4" src="../assets/images/play_4.png" alt="" />
        </swiper-slide>
        <swiper-slide class="swiper-slide">
          <img src="../assets/images/banner_5.jpg" alt="" />
          <img id="play-5" src="../assets/images/play_5.png" alt="" />
        </swiper-slide>
      </swiper>
      <div class="navigation">
        <div class="prev swiper-button">
          <img src="../assets/images/prev.png" alt="" @click="clickPrev" />
        </div>
        <div class="swiper-pagination" slot="pagination" id="custom"></div>
        <!-- <div class="icons">
          <img
            v-for="(item, index) in 2"
            :src="require(`../assets/images/banner_icon_${index + 1}.jpg`)"
            :key="index"
            alt=""
          />
        </div> -->
        <div class="next swiper-button">
          <img src="../assets/images/next.png" alt="" @click="clickNext" />
        </div>
      </div>
    </div>
    <div class="video-mask" v-if="isShowVideo">
      <div class="video">
        <div class="close" @click="isShowVideo = false"></div>
        <video
          v-if="video_type === 'tw'"
          src="../assets/images/tw_ab.mp4"
          controls="controls"
          autoplay
          muted
          preload
          loop
          x5-video-player-fullscreen="true"
          x5-playsinline
          playsinline
          webkit-playsinline
          width="100%"
          height="100%"
        ></video>
        <video
          v-if="video_type === 'ry'"
          src="../assets/images/ry_ab.mp4"
          controls="controls"
          autoplay
          muted
          preload
          loop
          x5-video-player-fullscreen="true"
          x5-playsinline
          playsinline
          webkit-playsinline
          width="100%"
          height="100%"
        ></video>
        <iframe
          v-if="video_type === 'jhjy'"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/hCxklZz-Vhw"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
        <iframe
          v-if="video_type === 'sgz'"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/SZ25akBKxcQ?si=0yK7ZyyjVSy9MwrL"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
        <iframe
          v-if="video_type === 'pdd'"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/GYbD6qzBUVY?si=C_LSuYPpDBWJqPIN"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </div>
    </div>
    <div class="our-games">
      <h1 class="title">Our Games</h1>
      <div class="content">
        <div class="left-content">
          <img src="../assets/images/ryjq_logo.png" alt="" />
          <h2>Creative Idle RPG</h2>
          <div class="desc">
            Deploy heroes from 6 different fractions to customize your own
            <br />
            powerful lineup! Collect rich rewards even when off-line.<br />
            Ten minutes each day grants you fascinating gaming experience.<br />
            A blissful relaxation with cleverly designed characters and graphics. <br />Find all sorts of creative mini
            games here for your amusement!
          </div>
        </div>
        <div class="right-content">
          <img src="../assets/images/ryjq_role.png" alt="" />
        </div>
      </div>
      <div class="download">
        <img @click="goLink(0, 'gp')" src="../assets/images/download_1.png" alt="" />
        <img @click="goLink(0, 'ios')" src="../assets/images/download_2.png" alt="" />
        <img @click="goLink(0, 'fb')" src="../assets/images/download_3.png" alt="" />
        <img @click="goLink(0, 'discord')" src="../assets/images/download_4.png" alt="" />
      </div>
    </div>
    <div class="rod">
      <div class="content">
        <div class="role">
          <img src="../assets/images/rod_role.png" alt="" />
        </div>
        <div class="content-right">
          <img class="logo" src="../assets/images/rod_logo.png" alt="" />
          <h2>MMOARPG</h2>
          <div class="desc">
            동양풍 판타지 세계를 구현하는 역대급 3D MMOARPG 모바일 게임이 드디어 왔다!<br />
            훌륭한 화질 및 유창한 게임 체험으로 몰입감 UP↑<br />
            현실과 다른 세상, 선택권은 당신의 손에 있다!<br />
            이제 신의 영역에서 누벼라!<br />
          </div>
          <div class="download">
            <img @click="goLink(1, 'forum')" class="naver-game" src="../assets/images/naver_game.png" alt="" />
            <img @click="goLink(1, 'gp')" src="../assets/images/download_1.png" alt="" />
            <img @click="goLink(1, 'onestore')" src="../assets/images/download_5.png" alt="" />
            <!-- <img @click="goLink(1, 'ios')" src="../assets/images/download_2.png" alt="" /> -->
          </div>
        </div>
      </div>
    </div>
    <div class="jhjy">
      <div class="content-bg">
        <div class="content">
          <img class="logo" src="../assets/images/jhjy_logo.png" alt="" />
          <div class="title">다종 형태 진화 미소녀 육성 RPG</div>
          <p class="desc">
            욕망과 갈등이 빚어낸 세계<br />
            인간과 엘프 사이에서 전쟁이 벌어졌다!<br />
            유일하게 진화의 힘을 가진 당신은 <br />
            이 무너질 세계를 구할 수 있는 책임을 맡게 되었다!<br />
            이제 당신이 움직여야 할 차례다!
          </p>
          <div class="download">
            <img @click="goLink(2, 'gp')" src="../assets/images/download_1.png" alt="" />
            <img @click="goLink(2, 'onestore')" src="../assets/images/download_5.png" alt="" />
            <img @click="goLink(2, 'ios')" src="../assets/images/download_2.png" alt="" />
            <img @click="goLink(2, 'galaxy')" src="../assets/images/download_7.png" alt="" />
          </div>
        </div>
        <div class="role-bg"></div>
      </div>
    </div>

    <!-- 像素三国 start -->
    <div class="sgz">
      <div class="content-bg">
        <div class="content">
          <img class="logo" src="../assets/images/sgz_logo.png" alt="" />
          <div class="title">日式超懷舊像素風三國RPG</div>
          <p class="desc">
            日式超懷舊像素風+鏡像級還原三國劇情<br />
            掛機自動無限推關+好康福利滾滾來<br />
            超豪華武將陣容+多樣BUFF自由疊加<br />
            千人PVP大規模攻城戰+經典回合制RPG
          </p>
          <div class="download">
            <img
              @click="goLink(3, 'gp')"
              src="../assets/images/download_googleplayTW.png"
              alt=""
              class="googleplay-tw-icon"
            />
            <img
              @click="goLink(3, 'galaxy')"
              src="../assets/images/download_galaxy_storeTW.png"
              alt=""
              class="galaxy-store-icon"
            />
            <img @click="goLink(3, 'ios')" src="../assets/images/download_appleTW.png" alt="" class="apple-tw-icon" />
          </div>
        </div>
      </div>
    </div>
    <!-- 像素三国 end -->

    <!-- 胖嘟嘟三国 start -->
    <div class="pdd-sg">
      <div class="content-bg">
        <div class="content">
          <img class="logo" src="../assets/images/qqsg_logo.png" alt="" />
          <div class="title">胖嘟嘟的三國放置RPG</div>
          <p class="desc">
            三國熱血題材、Q萌球形畫風、輕鬆掛機放置，<br />
            盡在《這個三國胖嘟嘟》！！！<br />
            作為史上送最大的三國遊戲，<br />
            超高爆率！紅將直送！<br />
            我們——是認真的！
          </p>
          <div class="download">
            <img
              @click="goLink(4, 'gp')"
              src="../assets/images/download_googleplayTW.png"
              alt=""
              class="googleplay-reserve-icon"
            />
            <img
              @click="goLink(4, 'ios')"
              src="../assets/images/download_appleTW.png"
              alt=""
              class="apple-reserve-icon"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 胖嘟嘟三国 end -->

    <div class="privacy" id="anchor">
      <span @click="goLink(2, 'privacy')">Privacy Policy</span>
      <span @click="goLink(2, 'service')">Mobile Terms of Service</span>
    </div>
    <div class="footer">
      <div class="logo">
        <img src="../assets/images/logo.png" alt="" />
      </div>
      <div class="content">
        <div class="desc">
          HONGKONG HOOKYLIN TECHNOLOGY LIMITED, founded in April, 2022, aims to provide high-quality mobile games
          content and impeccable service to players all over the world. Our employees share values of honesty,
          innovation, decency, enthusiasm and effective teamwork, and are determined to forge and develop our own
          ecological chain in the mobile game industry.
        </div>
        <div class="rights">
          <span>FLAT 404A,4/F,BEVERLEY COMMERCIAL CENTRE, 87-105 CHATHAM RD SOUTH, TST HONG KONG</span>
          <div>
            <span>North America: cs_na@flame-games.com</span>
            <span>Korea: cs@flame-games.com</span>
          </div>
          <span>© 2024 Hooyklin All Rights Reserved.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  components: {},
  data() {
    const that = this
    return {
      video_type: '',
      isShowVideo: false, // 是否显示视频
      pddsg_list: {
        gp: 'https://play.google.com/store/apps/details?id=com.hookylin.tw.qqsg.gp',
        ios: 'https://apps.apple.com/tw/app/id6502481057'
      },
      sgz_list: {
        gp: 'https://play.google.com/store/apps/details?id=com.hookylin.tw.sftx.google',
        galaxy: 'https://galaxystore.samsung.com/detail/com.hookylin.tw.sftxgalaxystore',
        ios: 'https://apps.apple.com/tw/app/id6469019041'
      },
      ry_list: {
        gp: 'https://play.google.com/store/apps/details?id=com.hookylin.us.ryjq.google',
        ios: 'https://apps.apple.com/us/app/id6443894738',
        fb: 'https://www.facebook.com/profile.php?id=100086772595532',
        discord: 'https://discord.gg/SJGfcTME5R'
      },
      tw_list: {
        gp: 'https://play.google.com/store/apps/details?id=com.hookylin.kr.qyz.google',
        onestore: 'https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000764012&scYn=Y',
        forum: 'https://game.naver.com/lounge/REALM_OF_DEITY/home',
        ios: 'https://apps.apple.com/us/app/id6445803985'
      },
      jhjy_list: {
        gp: 'https://play.google.com/store/apps/details?id=com.hookylin.kr.jhjy.google',
        onestore: 'https://onesto.re/_1QR9v13',
        ios: 'https://apps.apple.com/kr/app/id6447152130',
        galaxy: 'https://apps.samsung.com/appquery/preOrderDetail.as?contentId=000006819305'
      },
      footer_list: {
        service: 'https://op-static.hookylin.com/us/mobile-terms-of-service.html',
        privacy: 'https://op-static.hookylin.com/us/privacy-policy.html'
      },
      thumbsList: ['../assets/images/banner_icon_1.jpg', '../assets/images/banner_icon_2.jpg'],
      // 轮播图配置
      swiperOptions: {
        autoplay: {
          delay: 5000, //滚动时间间隔
          disableOnInteraction: true //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1,
        centeredSlides: true,
        // spaceBetween: '-20%',
        // spaceBetween: 10,
        // history: 'love',
        // 设置点击箭头
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        },
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            let _html = ''
            for (let i = 1; i <= total; i++) {
              if (current == i) {
                _html += `<div class="swiper-pagination-custom-item">
                  <div class="custom active-custom" index="${i}">
                    <img class="custom-img" index="${i}" src="${require(`../assets/images/banner_icon_${i}.jpg`)}" alt="">
                    <div class="mask" index="${i}" ></div>
                  </div>
                </div>`
              } else {
                _html += `<div class="swiper-pagination-custom-item">
                  <div class="custom" index="${i}">
                    <img class="custom-img" index="${i}" src="${require(`../assets/images/banner_icon_${i}.jpg`)}" alt="">
                      <div class="mask" index="${i}" ></div>
                  </div>
                </div>`
              }
            }
            return _html
          }
        },
        on: {
          click: function (e) {
            that.slideClick(e, this.realIndex)
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  created() {},
  mounted() {
    this.customBox = document.getElementById('custom')
    this.customBox.addEventListener('click', this.handleClick, false)
  },
  methods: {
    // 链接跳转
    goLink(index, key) {
      let href
      if (index === 0) {
        href = this.ry_list[key]
      } else if (index === 1) {
        href = this.tw_list[key]
      } else if (index === 2) {
        href = this.jhjy_list[key]
      } else if (index === 3) {
        href = this.sgz_list[key]
      } else if (index === 4) {
        href = this.pddsg_list[key]
      } else {
        href = this.footer_list[key]
      }
      window.open(href, '_balnk')
    },
    // about us跳转
    jumpClick() {
      document.querySelector('#anchor').scrollIntoView(true)
      //如果为true，元素的顶端将和其所在滚动区的可视区域的顶端对齐
      //如果为false，元素的底端将和其所在滚动区的可视区域的底端对齐
    },
    // 为了过滤loop产生的重复的slide
    slideClick(e, index) {
      const id = e.target.id
      console.log(id)
      if (id === 'play') {
        this.ryPlay()
      } else if (id === 'play-2') {
        this.twPlay()
      } else if (id === 'play-3') {
        this.jhjyPlay()
      } else if (id === 'play-4') {
        this.sgzPlay()
      } else if (id === 'play-5') {
        this.pddPlay()
      }
    },
    // 弹出视频
    pddPlay() {
      this.isShowVideo = true
      this.video_type = 'pdd'
    },
    sgzPlay() {
      this.isShowVideo = true
      this.video_type = 'sgz'
    },
    ryPlay() {
      this.isShowVideo = true
      this.video_type = 'ry'
    },
    twPlay() {
      this.isShowVideo = true
      this.video_type = 'tw'
    },
    jhjyPlay() {
      this.isShowVideo = true
      this.video_type = 'jhjy'
    },
    // icons跳转slide
    handleClick(e) {
      // 获取目标元素，拿到目标元素上的 index 值
      const current = e.target
      const toCount = current.attributes['index'].value || ''
      // 跳转到指定的 swiper 页面
      if (toCount) {
        this.swiper.slideTo(toCount)
      }
    },
    /* 前一步 */
    clickPrev() {
      // const that = this
      // const length = that.deviceList.length
      // if (that.activeBtn <= 0 || length == 0) {
      //   return false
      // }
    },
    /* 后一步 */
    clickNext() {
      // const that = this
      // const length = that.deviceList.length
      // if (that.activeBtn >= length - 1 || length == 0) {
      //   return false
      // }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/keyframes.less';
@import '../assets/css/pc.less';
.page {
}
// /* PC端 */
// @media screen and (min-width: 769px) {
// }
// /* 移动端  */
// @media screen and (max-width: 769px) {
//   @import '../assets/css/m.less';
// }
</style>
